import { render, staticRenderFns } from "./AdminContacts.vue?vue&type=template&id=70839f2b&scoped=true&"
import script from "./AdminContacts.vue?vue&type=script&lang=js&"
export * from "./AdminContacts.vue?vue&type=script&lang=js&"
import style0 from "./AdminContacts.vue?vue&type=style&index=0&id=70839f2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70839f2b",
  null
  
)

export default component.exports